import { useState } from "react";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import "../BucketwiseTable/BucketwiseTable.scss";
import { Flex, Skeleton } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import ColumnToggle from "../ColumnToggle/ColumnToggle";



const BucketStatusTable = ({ data, loading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const allColumns = [
    { title: "Bucket Group", dataIndex: "bucket", key: "bucket",render: (text) => loading ? <Skeleton.Input size="small" active /> : text || 'NA' },
    { title: "Roll Back", dataIndex: "rollback", key: "rollback", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
    { title: "Roll Forward", dataIndex: "rollforward", key: "rollforward", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
    { title: "Stabilized", dataIndex: "stabilized", key: "stabilized", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
    { title: "Normalized", dataIndex: "normalized", key: "normalized", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
    { title: "Total Cases", dataIndex: "total_cases", key: "total_cases", render: (text) => loading ? <Skeleton.Input size="small" active /> : text },
  ];
  const [visibleColumns, setVisibleColumns] = useState(
    allColumns.map((col) => col.key)
  );
  const columns = allColumns
    .filter((col) => visibleColumns.includes(col.key))
    .map((col) => ({
      ...col,
      label: col.title,
      title: (
        <span className="col-head">
          {col.title}
          {visibleColumns.length > 1 && (
            <CloseOutlined
              className="col-hide"
              title={`Hide ${col.title}`}
              onClick={(e) => {
                e.stopPropagation();
                setVisibleColumns(visibleColumns.filter((k) => k !== col.key));
                setHiddenColumns([...hiddenColumns, col.key]);
              }}
            />
          )}
        </span>
      ),
    }));

  if (hiddenColumns.length > 0) {
    columns.push({
      title: (
        <ColumnToggle
          hidden={hiddenColumns}
          allColumns={allColumns}
          onRestore={(key) => {
            const keys = Array.isArray(key) ? key : [key];
            setVisibleColumns([...visibleColumns, ...keys]);
            setHiddenColumns(hiddenColumns.filter((k) => !keys.includes(k)));
          }}
        />
      ),
      dataIndex: "__addColumn__",
      key: "__addColumn__",
      width: 56,
      align: "center",
      render: () => null,
      sorter: false,
    });
  }

  const formattedData = data &&  Object.entries(data)?.map(([key, value]) => ({
    key,
    ...value
  }));


  return (
    <Flex className="bucketwiseContainer">
      <ReusableTable
        columns={columns}
        dataSource={loading ? Array(8).fill({}) : formattedData}
        rowKey="bucketGroup"
        bordered
        pageSize={pageSize}
        CurrentPageNo={currentPage}
        totalItems={formattedData?.length || 0}
        setPageSize={setPageSize}
        triggerChange={(page, size) => {
          setCurrentPage(page);
          setPageSize(size);
        }}
      />
    </Flex>
  );
};

export default BucketStatusTable;
